import ActiveValue from "~types/ActiveValue";

function getStatementText(id: number, valueList: Array<ActiveValue>) {
  const statementObj = valueList.filter(
    valueStatement => valueStatement.statementId === id
  );
  return statementObj[0].statementText;
}

export default getStatementText;
